import { dasModal } from "../modal_v2.js";
import { matchService } from "./matchService_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { currentMatch } from "./currentMatch_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { iPop } from "../ipop_v2.js";
import { scoreBoard } from "../scoreBoard/scoreBoard_v2.js";

const handleCancelRequest = () => {
  dasModal.render(
    `<div class="max" style="flex-direction:column;">
    <div class=popUpHead>Cancel</div>
    <div id="cancelRequestContainer">
      <div id="cancelRequestContent">
          Are you sure you want to cancel this match?
          <div id="cancelRequestSplainer" class="i">ⓘ</div>
      </div>
      <div id="cancelRequestButtons">
        <button class="ruSure" id=cancelConfirmed>Yes</button>
        <button class="ruSure"  id=dontCancel>No</button>
      </div>
    </div>
    </div>
    `,
  );
};

const renderCancelRequestSplainer = (event) => {
  iPop.render({
    text: "Canceling will delete this match entirely. It will not affect your rank.",
    event,
  });
};

const handleCancelConfirmed = async () => {
  dasModal.close();
  await matchService.notifyCancel();

  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }

  await board.render();
  await scoreBoard.render();
};

const handleGotCancelNotification = () => {
  dasModal.close();
  dasModal.render(
    `<div class="max" style="flex-direction:column;">
    <div class=popUpHead>Cancelled</div>
    <p>This match has been cancelled.</p> 
    <p>It will be deleted entirely. This does not affect your rank.</p>
    <br>
    <button class="ruSure" id=okCancel>OK</button>
    <div class="courier" id="cancelMsg"></div>
    <br>
    </div>
    `,
  );
};

const handleOkCancel = async () => {
  dasModal.close();
  const okCancel = document.getElementById("okCancel");
  const cancelMsg = document.getElementById("cancelMsg");
  if (okCancel) {
    okCancel.disabled = true;
    okCancel.style.cursor = "wait";
  }
  if (cancelMsg) {
    cancelMsg.innerText = "Submitting...";
  }
  document.body.style.cursor = "wait";

  await matchService.cancel();

  if (okCancel) {
    okCancel.disabled = false;
    okCancel.style.cursor = "default";
  }
  document.body.style.cursor = "default";
  if (cancelMsg) {
    cancelMsg.innerText = "";
  }
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
};
eventHub.registerEvent(
  "click",
  "cancelRequestSplainer",
  renderCancelRequestSplainer,
);
eventHub.registerEvent("click", "dontCancel", dasModal.close);
eventHub.registerEvent("click", "cancelConfirmed", handleCancelConfirmed);
eventHub.registerEvent("click", "okCancel", handleOkCancel);

export const cancel = {
  handleCancelRequest,
  handleGotCancelNotification,
};
